import api from "./api";
import { BaseResponse, WarehouseResponse } from "../types/responses.type";

class WarehousesService {
  async getWarehouses(): Promise<BaseResponse<WarehouseResponse[]>> {
    try {
      const response = await api.get("/warehouse");
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch warehouses",
      };
    }
  }
}

export default new WarehousesService();
